import { Task } from "../redux/tasks/actions";

const formatViews = (views: number): string => {
    if (views >= 1000000) {
        return `${(views / 1000000).toFixed(1)}M`;
    }
    else if (views >= 1000) {
        return `${(views / 1000).toFixed(1)}K`;
    }
    return views.toString();
};

export const getMoneyFormat = (val: string|number|null|undefined, prefix?: string) => {
    if (val === null || val === undefined || val === "") {
        return 'N/A';
    } else {
        return (prefix === undefined ? "$" : prefix) + val.toLocaleString('en-us')
    }
};

export const getPercentFormat = (val: string|number|null|undefined, prefix?: string) => {
    if (val === null || val === undefined || val === "") {
        return 'N/A';
    } else {
        return val.toLocaleString("en-us") + (prefix === undefined ? "%" : prefix);
    }
};

export const getTextFormat = (val: string|number|null|undefined) => {
    if (!val) {
        return 'N/A';
    } else {
        return val
    }
};

export const getDateTimeFormat = (val: string|number|null|undefined) => {
    if (!val) {
        return 'N/A';
    } else {
        return new Date(val).toLocaleString();
    }
};

export const getVehicleStatusColor = (status: string) => {
    if (status == 'pending_delivery') {
        return "warning"
    } else if (status == 'sold') {
        return "success"
    } else if (status == 'mechanic_fix') {
        return "primary"
    } else if (status == 'ready_for_sale') {
        return "info"
    } else {
        return "secondary"
    }
};

export const getPartStatusColor = (status: string) => {
    if (status == 'New') {
        return "success"
    } else if (status == 'Refurbished') {
        return "warning"
    } else {
        return "error"
    }
};

export const getRatingColor = (score: string|number) => {
    if (typeof score === 'number') {
        if (score > 4) {
            return "success"
        } else if (score > 3) {
            return "warning"
        } else if (score > 2) {
            return "error"
        }
    } else {
        if (score === 'A' || score === 'Ready for sale') {
            return "success"
        } else if (score === 'B') {
            return "warning"
        } else if (score === 'C') {
            return "error"
        } else {
            return "secondary"
        }
    }
};

export const getFileTypes = (f: string) => {
    if (f.includes(".pdf")) {
        return "PDF File";
    } else if (f.includes(".jpg") || f.includes(".jpeg") || f.includes(".png")) {
        return "Image File";
    } else {
        return "Other";
    }
};

export const getTaskStatus = (task: Task) => {
    if (task?.is_complete) {
        return "Completed";
    } else if (task?.blocked_by?.length && task.blocked_by.filter((blocker: Task) => !blocker.is_complete).length > 0) {
        return "Blocked";
    } else if (task?.assignee_id && (!task?.due_date || new Date(task?.due_date) > new Date())) {
        return "In Progress";
    } else if (task?.assignee_id && task?.due_date) {
        return "Overdue"
    } else {
        return "Not Started";
    }
};

export const getTaskStatusColor = (task: Task) => {
    const status = getTaskStatus(task);
    if (status === "Completed") {
        return "success";
    } else if (status === "In Progress") {
        return "warning";
    } else if (status === "Overdue") {
        return "error";
    } else if (status === "Blocked") {
        return "error";
    } else {
        return "secondary";
    }
};



export default formatViews;